module.exports = {
    'regular' : [
                    {  text: 'Avvocato', value: 'lawyer' },
                    {  text: 'Ufficio Legale / Azienda', value: 'private_legal_office' },
                    {  text: 'Ufficio Legale / Ente Pubblico', value: 'public_entity' },
                    {  text: 'Magistrato', value: 'judge' }
                ],
    'rome_special_offer' : [
                    {  text: 'Avvocato iscritto all\'Ordine', value: 'rome_order_lawyer' }
                ]

}